<template>
  <el-table-column
    prop="subscribers"
    label="Feliratkozók"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      <el-tooltip placement="top" style="max-width: 300px;" popper-class="permission-info-tooltip">
        <div slot="content">
          <span v-if="scope.row.subscribers.length">{{ scope.row.subscribers.map(p => p.last_name +' '+ p.first_name).join(', ') }}</span>
          <span v-if="!scope.row.subscribers.length">Nem tartozik feliratkozó ehhez a feladathoz</span>
        </div>
        <el-tag v-if="scope.row.subscribers.length"> {{ scope.row.subscribers.length }} feliratkozó</el-tag>
        <el-tag type="danger" v-if="!scope.row.subscribers.length">Nincs feliratkozó</el-tag>
      </el-tooltip>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'subscribers',
  };
</script>
